import { createListenerMiddleware } from '@reduxjs/toolkit';

import { LanguageStore } from 'app/lang';
import { getClientInfo } from 'app/lib/account/actions';
import { cookie } from 'app/packages/lib';
import { SELECTED_LANGUAGE } from 'app/ssr/config';

export const setLanguage = createListenerMiddleware();

setLanguage.startListening({
  actionCreator: getClientInfo.fulfilled,
  effect: async (action) => {
    await LanguageStore.changeLanguage(action.payload.data.language);
    cookie.setCookie(SELECTED_LANGUAGE, action.payload.data.language);
  },
});
